/* eslint-disable import/prefer-default-export */

import { useSelector } from 'react-redux';

export const useCompanies = () => {
  const allCompanies = useSelector(state => state.AppState.companies.docs);

  return {
    allCompanies,
  };
};
